import React, { Component } from 'react';
import { Stage, Layer, Image } from 'react-konva';
import AvatarGroup from './components/AvatarGroup/AvatarGroup';
import Controls from './components/Controls/Controls';
import classes from './App.css';
import backgrounds from './img/backgrounds/Backgrounds';
import avatars from './img/avatar/Avatar';
import giftsList from './img/gifts/gifts';
// import styles from './UI/Styles/Styles';
import palette from './UI/Palette/Palette';
import ControlsToggle from './components/ControlsToggle/ControlsToggle';
import Gift from './components/Gifts/Gift';
import StandartBackground from './img/bg_standart.png';
// import audioTrack from './music/music.mp3';
// import ReactAudioPlayer from 'react-audio-player';
import MetaTags from 'react-meta-tags';
import ogImage from './img/og.jpg?v2';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width:
        window.innerWidth > 960
          ? 960 - 260
          : window.innerWidth > 768
          ? window.innerWidth - 260
          : window.innerWidth,
      height:
        window.innerWidth > 960
          ? 960 - 260
          : window.innerWidth > 768
          ? window.innerWidth - 260
          : window.innerWidth,
      background: null,
      standartBackground: null,
      currentBackground: 0,
      // imgSide: 300,
      imgSide: 0,
      // imgSide:
      //   ((window.innerWidth > 640 ? 640 : window.innerWidth) / 1.333) * 0.8,
      // sideWidth: 300,
      sideWidth:
        window.innerWidth > 960
          ? 960 - 260
          : window.innerWidth > 768
          ? window.innerWidth - 260
          : window.innerWidth,
      // sideHeight: 300,
      sideHeight:
        window.innerWidth > 960
          ? 960 - 260
          : window.innerWidth > 768
          ? window.innerWidth - 260
          : window.innerWidth,
      avatarPosition: null,
      showPalette: false,
      showGiftPalette: false,
      showControls: window.innerWidth > 768,
      gifts: [],
      giftsList,
      elementsIndex: 0,
      avatarZIndex: 1,
      bgZIndex: 2,
      giftsZIndex: 10000,
      photoEditing: true,
      sendEnabled: false,
      showSaveBtn: false,
      // showDeleteButton: false,
      uploadedPhoto: false,
      // playMusic: false,
      controlsStatus: 'step0',
    };
  }
  currentBackground = 0;

  componentDidMount() {
    const image = new window.Image();
    const imageStandartBackground = new window.Image();
    image.src = backgrounds[0];
    imageStandartBackground.src = StandartBackground;
    image.onload = () => {
      this.setState({
        background: image,
        standartBackground: imageStandartBackground,
        avatarZIndex: 300,
        bgZIndex: 0,
      });

      this.stage.getStage().findOne('.avatar').opacity(1);
    };
  }

  // addGift = (e,
  //            name,
  //            x = this.state.width/2 - 225 + Math.floor(Math.random()*200),
  //            y = this.state.height/1.6 - 225 + Math.floor(Math.random()*200),
  //            side = 125) => {
  //   let gifts = this.state.gifts;
  //   let image = new window.Image();
  //   giftsList.forEach(g => {
  //     if (g.name === name) {
  //       image.src = g.url;
  //     }
  //   });
  //   gifts.push({name: name, x: x, y: y, side: side, image: image, zIndex: this.state.giftsZIndex});
  //   this.showCloseGiftPalette(false);
  //   this.increaseIndex();
  //   this.setState({
  //     gifts: gifts
  //   })
  // };

  componentDidUpdate() {}

  increaseIndex = () => {
    this.setState({
      elementsIndex: this.state.elementsIndex + 1,
    });
    // console.log(this.state.elementsIndex);
  };

  toggleControls = () => {
    this.setState((prevState) => {
      return { showControls: !prevState.showControls };
    });
  };

  openControls = () => {
    this.setState({
      showControls: true,
    });
  };

  onInputChange = (e, prop) => {
    this.setState({ [prop]: e.target.value });
  };

  onInputCheck = (e, prop) => {
    this.setState((prevState) => ({ [prop]: !prevState[prop] }));
  };

  setInitialPosition = (x, y, prop) => {
    if (this.state.uploadedPhoto === true) {
      this.setState({ [prop]: { x, y } });
    }
  };

  chooseNextBackground = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = backgrounds[this.currentBackground + 1]
      ? backgrounds[this.currentBackground + 1]
      : backgrounds[0];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne('.background').getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne('.background').getLayer().batchDraw();
      if (this.state.uploadedPhoto === false) {
        this.chooseNextAvatar();
      }
      this.currentBackground =
        this.currentBackground + 1 < backgrounds.length ? this.currentBackground + 1 : 0;
      this.setState({
        currentBackground: this.currentBackground,
      });
    };

    if (this.state.uploadedPhoto === true) {
      this.changePhoto();
    }
  };

  choosePrevBackground = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = backgrounds[this.currentBackground - 1]
      ? backgrounds[this.currentBackground - 1]
      : backgrounds[backgrounds.length - 1];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne('.background').getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne('.background').getLayer().batchDraw();
      if (this.state.uploadedPhoto === false) {
        this.choosePrevAvatar();
      }
      this.currentBackground =
        this.currentBackground - 1 > -1
          ? this.currentBackground - 1
          : backgrounds.length - 1;
      this.setState({
        currentBackground: this.currentBackground,
      });
    };

    if (this.state.uploadedPhoto === true) {
      this.changePhoto();
    }
  };

  chooseNextAvatar = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = avatars[this.currentBackground + 1]
      ? avatars[this.currentBackground + 1]
      : avatars[0];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne('.avatar').getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne('.avatar').getLayer().batchDraw();
    };

    if (this.state.uploadedPhoto === true) {
      this.changePhoto();
    }
  };

  choosePrevAvatar = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = avatars[this.currentBackground - 1]
      ? avatars[this.currentBackground - 1]
      : avatars[backgrounds.length - 1];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne('.avatar').getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne('.avatar').getLayer().batchDraw();
    };

    if (this.state.uploadedPhoto === true) {
      this.changePhoto();
    }
  };

  // chooseRandBackground = () => {
  //   const bckgrndImg = new window.Image();
  //   const randBcgr = Math.floor(Math.random() * backgrounds.length);
  //   bckgrndImg.src = backgrounds[randBcgr];
  //   bckgrndImg.onload = () => {
  //     this.stage.getStage().findOne(".background").getImage().src = bckgrndImg.src;
  //     this.stage.getStage().findOne(".background").getLayer().batchDraw();
  //     this.currentBackground = randBcgr;
  //   };
  // };

  changePhoto = () => {
    // if (this.state.uploadedPhoto === true) {
    this.setState({ photoEditing: true });
    this.stage.getStage().findOne('.avatarGroup').moveToTop();
    this.stage.getStage().findOne('.avatar').opacity(0.7);
    this.setState({
      avatarZIndex: 300,
      giftsZIndex: 1000,
      bgZIndex: 0,
    });
    this.stage.getStage().findOne('.avatarGroup').getLayer().batchDraw();
    // }
  };
  stopChangingPhoto = () => {
    // if (this.state.uploadedPhoto === true) {
    this.setState({ photoEditing: false });
    this.stage.getStage().findOne('.avatarGroup').moveToBottom();
    this.stage.getStage().findOne('.avatar').opacity(1);
    this.setState({
      avatarZIndex: 1,
      giftsZIndex: 1000,
      bgZIndex: 2,
    });
    this.stage.getStage().findOne('.avatarGroup').getLayer().batchDraw();
    // }
  };

  onFileInputChange = (e) => {
    const newAvatar = new window.Image();
    //newAvatar.setAttribute('crossOrigin', 'anonymous');
    newAvatar.onload = () => {
      let width = newAvatar.width;
      let height = newAvatar.height;
      if (width > height) {
        const k = width / height;
        if (width >= window.innerWidth / 2) {
          width = window.innerWidth / 2;
          height = width / k;
        }
        newAvatar.width = width;
        newAvatar.height = height;
      } else {
        const k = height / width;
        if (height >= window.innerHeight / 2) {
          height = window.innerHeight / 2;
          width = height / k;
        }
        newAvatar.width = width;
        newAvatar.height = height;
      }
      console.log(newAvatar.width);
      console.log(newAvatar.height);
      console.log(this.stage.getStage().findOne('.avatar').getImage());
      this.stage.getStage().findOne('.avatar').getImage().src = newAvatar.src;
      this.stage.getStage().findOne('.avatar').getLayer().batchDraw();
      this.setState({
        sideHeight: newAvatar.height,
        sideWidth: newAvatar.width,
      });
      console.log(this.state.sideWidth);
      console.log(this.state.sideHeight);
    };
    newAvatar.src = window.URL.createObjectURL(e.target.files[0]);
    this.changePhoto();
    this.setState({
      uploadedPhoto: true,
    });
    window.ym(92741705, 'reachGoal', 'uploadImage');
  };

  disableTransform = () => {
    let transformArray = [];
    transformArray.push(this.stage.getStage().findOne('.avatar-transform'));
    transformArray.push(this.stage.getStage().find('.newTexts-tranformer'));
    this.stage
      .getStage()
      .find('Transformer')
      .forEach((transformer) => {
        if (~transformer.name().indexOf('gift-transform')) {
          transformArray.push(transformer);
        }
      });
    transformArray.push(this.stage.getStage().find('.gift-transform'));
    transformArray.forEach((item) =>
      item.resizeEnabled(false).rotateEnabled(false).borderEnabled(false).forceUpdate()
    );
    transformArray[0].getLayer().batchDraw();
    // this.stage
    //   .getStage()
    //   .find((node) => {
    //     return (
    //       node.getName() === "text1-zoomer" ||
    //       node.getName() === "text2-zoomer" ||
    //       node.getName() === "text3-zoomer"
    //     );
    //   })
    //   .forEach((zoomer) => zoomer.hide());
    // const imagesColletion = this.stage.getStage().find(".deleteButton");
    // for (let i = 0; i < imagesColletion.length; i++) {
    //   imagesColletion[i].setAttr("visible", false);
    // }
  };

  enableTransform = (elem) => {
    if (~elem.name().indexOf('gift')) {
      // elem.parent.findOne(".deleteButton").setAttr("visible", true);
      elem.parent
        .findOne('Transformer')
        .rotateEnabled(true)
        .borderEnabled(true)
        .resizeEnabled(true);
      elem.parent.findOne('Transformer').getLayer().batchDraw();
      elem.parent.findOne('Transformer').forceUpdate();
    }
  };

  toggleShowPalette = () => {
    this.setState((prevState) => ({
      showPalette: !prevState.showPalette,
    }));
  };

  toggleShowGiftPalette = () => {
    this.setState((prevState) => ({
      showGiftPalette: !prevState.showGiftPalette,
    }));
  };

  showCloseGiftPalette = (show) => {
    this.setState({
      showGiftPalette: show,
    });
  };

  onStageClick = (e) => {
    this.stage.getStage();
    this.stage.forceUpdate();
    if (e.target.name() === 'background') {
      this.disableTransform();
      this.showCloseGiftPalette(false);
      this.setState({
        avatarZIndex: 2,
      });
    } else if (~e.target.name().indexOf('gift')) {
      this.disableTransform();
      this.showCloseGiftPalette(false);
      // this.setState({
      //   avatarZIndex: 1000
      // });
      this.enableTransform(e.target);
    } else if (~e.target.name().indexOf('avatar')) {
      this.showCloseGiftPalette(false);
      // this.setState({
      //   avatarZIndex: 1
      // });
      if (this.state.uploadedPhoto === false) {
        if (document.getElementById('loadAvatar')) {
          document.getElementById('loadAvatar').click();
        }
      }
    }

    // document.getElementById("controls").click();

    // if (this.state.playMusic === false) {
    //   document.getElementById('looptrack').play();
    //   this.setState({
    //     playMusic: true,
    //   });
    // }
  };

  saveStage = () => {
    let downloadURI = (uri, name) => {
      if (window.navigator.msSaveBlob) {
        let dataURItoBlob = (uri) => {
          var binary = atob(uri.split(',')[1]);
          var array = [];
          for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
          }
          return new Blob([new Uint8Array(array)], { type: 'image/png' });
        };
        var blob = dataURItoBlob(uri);
        window.navigator.msSaveOrOpenBlob(blob, 'giftcard.png');
      } else {
        var link = document.createElement('a');
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    };
    // setTimeout, чтобы конва успела удалить рамки, если пользователь этого не сделал, и перерисоваться
    setTimeout(() => {
      let dataURL = this.stage.getStage().toDataURL({
        mimeType: 'image/png',
        quality: 1.0,
      });
      downloadURI(dataURL, 'giftcard.png');
    }, 400);
    window.ym(92741705, 'reachGoal', 'savePicture');
  };

  addShape = (e, sType) => {
    let newCustomShapes = this.state.customShapes;
    newCustomShapes.push({ type: sType });
    this.increaseIndex();
    this.setState({
      customShapes: newCustomShapes,
    });
  };

  addGift = (
    e,
    name,
    x = this.state.width / 2 - 225 + Math.floor(Math.random() * 200),
    y = this.state.height / 1.6 - 225 + Math.floor(Math.random() * 200),
    side = 125
  ) => {
    let gifts = this.state.gifts;
    let image = new window.Image();

    if (this.state.photoEditing === false && this.state.uploadedPhoto === true) {
      if (gifts.length === 0) {
        gifts.push({
          name: 'fake',
          x: -100,
          y: -100,
          side: true,
          image: image,
          zIndex: 0,
        });
      }

      giftsList.forEach((g) => {
        if (g.name === name) {
          image.src = g.url;
        }
      });
      gifts.push({
        name: name,
        x: x,
        y: y,
        side: side,
        image: image,
        zIndex: this.state.giftsZIndex,
      });
      this.showCloseGiftPalette(false);
      this.increaseIndex();
      this.setState({
        gifts: gifts,
      });
    }
  };

  makeCounter = () => {
    let count = 1;
    return () => {
      return count++;
    };
  };

  sendToServer = () => {
    /*        this.disableTransform();

     const makeRequest = async () => {
     try {
     var XHR = window.XDomainRequest || window.XMLHttpRequest;
     var xhr = new XHR();
     xhr.open('POST', 'https://www.domkino.tv/vkcover/musketeer/photo', true);
     xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
     let dataURL = await this.stage.getStage().toDataURL();
     xhr.send('photo=' + encodeURIComponent(dataURL));
     xhr.onload = function() {
     alert( "Отерытка успешно отправлена" );
     }
     xhr.onerror = function() {
     alert( "Возникла ошибка. Попробуйте позже" );
     }
     } catch (err) {
     console.log(err)
     }
     }
     setTimeout(()=> {
     makeRequest();
     },400);*/
  };

  changeControlsStatus = (e, permit) => {
    if (permit === true) {
      this.setState({
        controlsStatus: e,
      });
    }
  };

  // deleteElement = (elem) => {
  //   const type = elem.__proto__.constructor.name.toLowerCase();
  //   if (type === "gift") {
  //     if (elem.transform.parent.findOne("Image")) {
  //       elem.transform.parent.findOne("Image").destroy();
  //       elem.transform.parent.findOne(".deleteButton").destroy();
  //     }
  //     elem.transform.rotateEnabled(false);
  //     elem.transform.borderEnabled(false);
  //     elem.transform.resizeEnabled(false);
  //     const newGiftsList = Array.from(this.state.gifts);
  //     for (let i = 0; i < newGiftsList.length; i++) {
  //       if (elem.props.i === newGiftsList[i]) {
  //         newGiftsList[i] = null;
  //       }
  //     }
  //     this.setState({
  //       gifts: newGiftsList,
  //     });
  //   } else if (type === "avatargroup") {
  //   }
  // };

  shareOnClick = () => {
    window.ym(92741705, 'reachGoal', 'share');
  };

  render() {
    return (
      <div className={classes.Main}>
        <MetaTags>
          <title>Создай свою открытку, добавь фото и поделись с друзьями.</title>
          <meta
            name="description"
            content="Создай свою праздничную открытку вместе с героями мультфильма «Зебра в клеточку»!"
          />
          <meta
            property="og:title"
            content="Праздничная открытка на «Зебра в клеточку. Яркие дни.»"
          />
          <meta property="og:image" content={ogImage} />
        </MetaTags>

        {/* <div className={classes.snowTime}>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
          <div className={classes.snow}></div>
        </div> */}

        <Stage
          width={this.state.width}
          height={this.state.width}
          ref={(node) => {
            this.stage = node;
          }}
          className={classes.Stage}
          onClick={(e) => this.onStageClick(e)}
          onTap={(e) => this.onStageClick(e)}>
          <Layer>
            {/*<Image*/}
            {/*  fill={"#eee"}*/}
            {/*  width={this.state.width}*/}
            {/*  height={this.state.height}*/}
            {/*/>*/}
            <Image
              name="standartBackground"
              image={this.state.standartBackground}
              width={this.state.width}
              height={this.state.height}
              zIndex={0}
            />
          </Layer>
          <Layer>
            <AvatarGroup
              x={
                this.state.avatarPosition
                  ? this.state.avatarPosition.x
                  : // : this.state.width / 2 - this.state.imgSide / 2
                    0
              }
              y={
                this.state.avatarPosition
                  ? this.state.avatarPosition.y
                  : // : this.state.height / 2 - this.state.imgSide / 2
                    0
              }
              sideHeight={this.state.sideHeight}
              sideWidth={this.state.sideWidth}
              zIndex={this.state.avatarZIndex}
              setInitialPosition={this.setInitialPosition}
              background={this.state.currentBackground}
              uploadedPhoto={this.state.uploadedPhoto}
            />
            <Image
              name="background"
              image={this.state.background}
              width={this.state.width}
              height={this.state.height}
              zIndex={this.state.bgZIndex}
            />
            {this.state.gifts.length > 0 &&
              this.state.gifts.map((gift, i) => {
                return (
                  <Gift
                    className={`gift`}
                    id={`gift-${i}`}
                    key={`gift-${i}`}
                    gift={gift}
                    giftsList={giftsList}
                    i={i}
                    x={gift.x}
                    y={gift.y}
                    side={gift.side}
                    image={gift.image}
                    setGiftInitialPosition={this.setInitialPosition}
                    zIndex={this.state.giftsZIndex}
                    // deleteElement={this.deleteElement}
                    dbVisible={this.state.showDeleteButton}
                  />
                );
              })}
          </Layer>
        </Stage>
        <Controls
          id={'controls'}
          open={this.state.showControls}
          toggleControls={this.toggleControls}
          palette={palette}
          showPalette={this.state.showPalette}
          toggleShowPalette={this.toggleShowPalette}
          onFileInputChange={this.onFileInputChange}
          onInputChange={this.onInputChange}
          onInputCheck={this.onInputCheck}
          chooseNextBackground={this.chooseNextBackground}
          choosePrevBackground={this.choosePrevBackground}
          onStageSave={this.saveStage}
          sendToServer={this.sendToServer}
          addShape={this.addShape}
          addGift={this.addGift}
          showGiftPalette={this.state.showGiftPalette}
          toggleShowGiftPalette={this.toggleShowGiftPalette}
          giftsList={giftsList}
          onClick={this.disableTransform}
          changePhoto={this.changePhoto}
          stopChangingPhoto={this.stopChangingPhoto}
          photoEditing={this.state.photoEditing}
          uploadedPhoto={this.state.uploadedPhoto}
          controlsStatus={this.state.controlsStatus}
          changeControlsStatus={this.changeControlsStatus}
          shareOnClick={this.shareOnClick}
        />
        <ControlsToggle click={this.toggleControls} />
        {/* <ReactAudioPlayer
          id="looptrack"
          src={audioTrack}
          loop={true}
          autoPlay={true}
          onPlay={(e) => console.log('onPlayMusic')}
        /> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js